module.exports = __webpack_public_path__ + "static/img/14003006.99d631a2.png";